import { render, staticRenderFns } from "./CustomFields.vue?vue&type=template&id=6966165b&scoped=true&"
import script from "./CustomFields.vue?vue&type=script&setup=true&lang=js&"
export * from "./CustomFields.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6966165b",
  null
  
)

export default component.exports